// Mock data for Norwood Advance LLC

export const mockISOSignup = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log('ISO Signup:', formData);
  return {
    success: true,
    message: 'ISO application submitted successfully! Our team will contact you within 24 hours.'
  };
};

export const mockBusinessApply = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log('Business Application:', formData);
  return {
    success: true,
    message: 'Application submitted! You will receive a decision within 4 hours.'
  };
};

export const states = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
];

export const faqData = [
  {
    question: 'What is the minimum credit score required?',
    answer: 'We require a minimum credit score of 650 for most financing products. However, we take a holistic approach to underwriting and consider multiple factors.'
  },
  {
    question: 'How quickly can I receive funding?',
    answer: 'Most approved applications receive funding within 24 hours. Our average decision time is 4 hours from application submission.'
  },
  {
    question: 'What is an ISO partnership?',
    answer: 'An ISO (Independent Sales Organization) partnership allows you to refer businesses to Norwood Advance and earn commissions on funded deals. Contact us to learn about our ISO program.'
  }
];